<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container class="ces-customize-view" fill-height fluid>
    <page-title title="CES Design"></page-title>
    
    <SingleChoiceQuestion
      v-if="view === routes.SURVEY_CUSTOMIZE_CES_QUESTION"
      :color="color"
      :options="choiceOptions"
      :brandName="currentCampaign.brand_name"
      :question="currentQuestion.question"
      :value="-1"
      :animationEnabled="currentCampaign.options.widget_settings.animation_enabled"
    >
      <template v-slot:question>
        <span class="design-label">
            Question: 
          </span>
        <span>{{ questionParts[0] }}</span>
        <input
          class="brand-title-input lgrm-box-input"
          type="text"
          :style="brandTitleInputStyle"
          v-model="brandName"
          disabled
        />
        <span>{{ questionParts[1] }}</span>
      </template>
    </SingleChoiceQuestion>
    <DriversDesign
      v-if="view === routes.SURVEY_CUSTOMIZE_CES_DRIVERS"
      :brandTitle="brandName"
      :question="currentQuestion"
      driver-status-label="Enable CES driver question for"
      @change="$emit('saveQuestion', currentQuestion)"
    ></DriversDesign>
    <OpenendedDesign
      v-if="view === routes.SURVEY_CUSTOMIZE_CES_OPEN_ENDED"
      :color="currentCampaign.primary_color"
      :brandTitle="brandName"
      :question="currentQuestion"
      @change="$emit('saveQuestion', currentQuestion)"
    ></OpenendedDesign>
  </v-container>
</template>

<script>
import routes from '@/route_names'
import constants from '@/constants'
import strings from '@/strings'
import SingleChoiceQuestion from '../../../../../widgets/feedback/src/components/SingleChoiceQuestion.vue'
// import EmojiRating from '../../../../../widget/src/components/feedback/emoji-rating/EmojiRating.js'
// import habitat from 'preact-habitat'
import DriversDesign from '@/components/survey/DriversDesign.vue'
import OpenendedDesign from '@/components/survey/OpenendedDesign.vue'
export default {
  name: 'CesView',
  props: {
    view: String,
    campaign: {
      type: Object
    },
    questions: {
      type: Array
    }
  },
  components: { SingleChoiceQuestion, DriversDesign, OpenendedDesign },
  mounted(){
    // let _habitat = habitat(module.default)
    //     _habitat.render({
    //       selector: '[data-widget-host="habitat"]',
    //       defaultProps: { options: {}, campaign: $this.campaign },
    //       clean: true
    //     })
  },
  data: function() {
    return {
      color: this.campaign.primary_color,
      brandName: this.campaign.brand_name,
      currentCampaign: this.campaign,
      choiceOptions: strings.ES.widget_button_labels
    }
  },
  computed: {
    routes: function() {
      return routes
    },
    questionParts: function() {
      if (this.currentQuestion) {
        return this.currentQuestion.question.split('{brand_name}')
      }

      return ['', '']
    },
    brandTitleInputStyle: function() {
      return {
        textAlign: 'center',
        width: this.brandName.length * 10 + 30 + 'px'
      }
    },
    currentQuestion: function() {
      let question = null
      if (!this.questions) return question
      if (this.view === routes.SURVEY_CUSTOMIZE_CES_QUESTION) {
        question = this.questions[0]
      }
      if (this.view === routes.SURVEY_CUSTOMIZE_CES_DRIVERS) {
        question = this.questions[1]
      }
      if (this.view === routes.SURVEY_CUSTOMIZE_CES_OPEN_ENDED) {
        question = this.questions[2]
      }
      console.log(question)
      return question
    }
  },
  methods: {
    save() {}
  }
}
</script>

<style></style>
